export default __webpack_public_path__ + "static/media/PlayBoy.ab41fe6f.png";